// extracted by mini-css-extract-plugin
export default {"SectionProductText":"SectionProductText_SectionProductText__C2G2h","Number":"SectionProductText_Number__wNvQ5"};